export function isSubscriber() {
  return !!window.location.hostname.match(/abonados/);
}

export function isBusiness() {
  return !!window.location.hostname.match(/comercios/);
}

export function isCabbie() {
  return !!window.location.hostname.match(/taxistas/);
}

export function isAreaSanitariaDeVigo() {
  return !!window.location.hostname.match(/asv/);
}
